import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Largura do conteúdo pela natureza da tela, não por tela: formulário lê melhor estreito,
 * tabela precisa de largura. Medida nova é decisão de design system: `2xl` é a de lista com
 * coluna de filtros ao lado (pedidos), que no `xl` apertava a tabela e deixava margem vazia.
 */
const SIZES = {
  sm: 'max-w-xl',
  md: 'max-w-3xl',
  lg: 'max-w-5xl',
  xl: 'max-w-6xl',
  '2xl': 'max-w-7xl',
} as const;

/** Contêiner de toda página dentro do shell: largura, respiro e espaço entre seções. */
export function Page({
  size = 'lg',
  className,
  children,
}: {
  size?: keyof typeof SIZES;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn('mx-auto flex w-full flex-col gap-6 p-4 sm:p-6', SIZES[size], className)}>
      {children}
    </div>
  );
}
